<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0040_certificate_information</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-search title="証書情報 (old)"></title-and-search>
          <search-control 
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
                              <div>
            <input 
              @click="allChecked($event.target.value,$event.target)"
              style="float: right;"
              v-model="checkBoxSelectAll"
              :disabled="approveMode == 'reject'"
              type="checkbox" id="checkBoxSelectAll" name="checkBoxSelectAll" value="X">
          </div>
          <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
          <div style="float: left;;margin-top:5px">
            件数
            </div>
            <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;float: left;margin-left:5px" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">
            <button
            :disabled="formExportFileDisabled || checkUserPermission(true,permissionMode.EXPORT) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #b83261;background: #337ab7;" @click="initExportFile" >出力</button>
            <button :disabled="deleteBtnDisabled || checkUserPermission(true,permissionMode.DELETE) == false"
            class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete" >{{deleteText}}</button>
            <button :disabled="formBatchEditDisabled || checkUserPermission(true,permissionMode.EDIT) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;" @click="bachEdit" 
             >{{batchEditText}}</button>
            <button :disabled="checkUserPermission(true,permissionMode.ADD) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;" @click="addNew">新規</button>

            <br>
            <br>
            <information-icon-modal tag = "showInformationIconModalCertificateInformation"/>
            <device-embedded-information-bach-edit-modal tag="showDeviceEmbeddedInformationBachEditModal" />
            <file-download-modal tag="runDeviceEmbeddedInformationDownloadModal" @close="onCloseExportFile"/>
          <confirmation-modal tag="deleteCertificateInformationModal" @done="onConfirmDelete" />
          </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import uuid from "uuid";
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_certificate_information';
import { utils } from '@/libs/utils';


import _debug from 'debug';
var mdebug = _debug('esma:certificate_information');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import fileDownloadModal from '@/components/modals/file-download-modal';
import { bus } from '@/libs/bus';
import deviceEmbeddedInformationBachEditModal from '@/components/modals/device-embedded-information-bach-edit-modal';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue,
    'device-embedded-information-bach-edit-modal' : deviceEmbeddedInformationBachEditModal,
    'file-download-modal':fileDownloadModal
  },
  data() {
    return {
      api_name:"certificate_information",
      page_acl: acl.certificate_information,
      detail_page:"page_0040_certificate_information_detail",
      execute_filter_on_back:true,
      link_to_open:"#",
      select_all:false
    };
  },
  computed: {
        approveMode:{
      get(){
        return this.approve_mode;
      },
      set(v){
        this.approve_mode = v;
      }
    },
    checkBoxSelectAll:{
      get(){
        return this.select_all;
      },
      set(v){
        this.select_all = v;
      }
    },
    deleteBtnDisabled(){
      return this.formOutputQty == 0 ||  typeof _.find(this.selectedRowArr,(d)=>{ return d.real_certificate_management_number != "" && d.real_certificate_management_number != null;}) != "undefined";
    },
    deleteText(){
      if(this.deleteBtnDisabled){
        return "削除";
      }else{
        return "削除 (" + this.formOutputQty + ")";
      }
    },
    linkToOpen:{
      get(){
        return this.link_to_open;
      },
      set(v){
        this.link_to_open = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.approval_status, {}),
        utils.extend(fields.status, {}),
        utils.extend(fields.registration_date, {}),
        utils.extend(fields.certificate_management_number, {tab_label:"証書管理番号",tab_size:60}),
        utils.extend(fields.company, {}),
        utils.extend(fields.licensed_department, {}),
        utils.extend(fields.license_jurisdiction_team, {}),
        utils.extend(fields.jurisdiction_classification, {}),
        utils.extend(fields.license_jurisdiction_system, {}),
        utils.extend(fields.license_name, {}),
        utils.extend(fields.effective_number, {}),
        utils.extend(fields.remaining_number, {}),
        utils.extend(fields.expiration_date, {type:filed_types.DATE_PICKER}),
        utils.extend(fields.maintenance_deadline, {type:filed_types.DATE_PICKER}),
      ];
    }
  },
  methods: {
    allChecked(a,b){
      this.commonAllChecked("showInformationIconModalCertificateInformation")
    },
    hideCheckBox(data){
      return (data && (data.approval_status == "申請中"))
    },
    onDelete(){
      bus.$emit("deleteCertificateInformationModal",{
        title: "削除",
        message: "証書情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        if(Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0){
          return;
        }
        var arr = this.selectedRowArr.map((m)=>{return m.seq_id;})
        var vm = this
        this.commonDeleteArr(vm,arr,()=>{
          // All Deleted
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    initExportFile(){
      //FILE_EXPORT_PART2 : Step 2
      bus.$emit("runDeviceEmbeddedInformationDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url:"/certificate_information/export_data/"
      });
    },
    onCloseExportFile(){},
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: {  seq_id:data.seq_id} });
    },
    addNew(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:"new"} });
    },
    bachEdit(){
      var p_id = uuid.v4()
      var obj = {arr:this.selectedRowArr.map(m=>{return m.seq_id})}
      Vue.localStorage.set("bulk_edit_" + p_id, JSON.stringify(obj))
      return this.$router.push("/certificate_information/bulk_edit/" + p_id);
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:true})
    },
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource();
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0040_certificate_information.vue?83da0ba8